<script lang="ts">

    import {NavigationState} from "../models/NavigationState";
    import {createEventDispatcher, onDestroy} from "svelte";
    import {NavigationStateStore, StoredApplicationData, StoredApplicationDataList, IncidentalError} from "../services/Store";
    import HonestyStatement from "./HonestyStatement.svelte";
    import TopLevelNavigation from "./TopLevelNavigation.svelte";
    import ApplicationSelection from "./ApplicationSelection.svelte";
    import {ApplicationData} from "../models/ApplicationData";
    import {
        applicationReviewCompleted,
        hipaaCompleted,
        identificationCompleted,
        medicalQuestionsCompleted
    } from "../services/NavigationService";
    import ApplicationDataContainer from "./ApplicationData/ApplicationDataContainer.svelte";
    import HipaaElectronicSignature from "./HipaaElectronicSignature.svelte";
    import MedicalQuestionsContainer from "./medicalQuestions/MedicalQuestionsContainer.svelte";
    import IdentificationCard from "./IdentificationCard.svelte";
    import {InsuredDetails} from "../models";
    import ReadyToBeContacted from "./ReadyToBeContacted.svelte";
    import PhoneInterviewInstructions from "./PhoneInterviewInstructions.svelte";
    import Modal from "./controls/Modal.svelte";
    import {ClearIncidentalError} from "../services/ErrorService";
    import {getEzAppToken} from "../services/Utilities";

    const dispatch = createEventDispatcher();
    let editMode = false;
    let validApplication = true;

    export let applicationData = new ApplicationData();
    let applicationDataList: ApplicationData[] = [];
    let insured: InsuredDetails;
    let pageTitle = "Welcome";
    let displayApplicationReview = false;
    let errorModal;
    const token = getEzAppToken();
    $: if (token) {
       const payload =  JSON.parse(window.atob(token.split('.')[1]));
        if (payload) {
          const givenName =  payload["given_name"];
           if (givenName) {
               pageTitle = "Welcome " + givenName;
           }
        }
    }
    $: if (applicationData) {
       // console.log('From container: ', applicationData.planDetails.policyNumber);
    }

    const applicationDataUnsubscribe = StoredApplicationData.subscribe(value => applicationData = value);
    onDestroy(applicationDataUnsubscribe);

    const applicationDataListUnsubscribe = StoredApplicationDataList.subscribe(value => applicationDataList = value);
    onDestroy(applicationDataListUnsubscribe);

    let navState = new NavigationState();
    const navStateUnsubscribe = NavigationStateStore.subscribe(value => navState = value);
    onDestroy(navStateUnsubscribe);

    const applicationSelected = (event) => {
        const applicationId = event.detail.applicationId;
        editMode = false;
        validApplication = true;
        dispatch('applicationSelected', applicationId);
    }

    const applicationReviewComplete = () => {
        applicationReviewCompleted();
    };

    const hipaaAuthorizationComplete = () => {
        hipaaCompleted();
    }

    const medicalQuestionsComplete = () => {
        medicalQuestionsCompleted();
    }

    const identificationCardComplete = () => {
        identificationCompleted();
    }

    $: if (applicationData) {
        if (applicationData.applicationId) {
            validApplication = true;
            insured = applicationData.insuredDetails;
        }
    }

    $: if (navState) {
        if (navState.applicationReview !== displayApplicationReview) {
            displayApplicationReview = navState.applicationReview;
        }
    }

    const closeModal = (event) => {
        event.preventDefault();
        ClearIncidentalError();
        errorModal.hide();
    }
</script>

<div class="navigation-container" >
    <div class="card-no-border">
        <h1>{pageTitle}!</h1>
        <div>
            Complete your request for Life Insurance to ensure a smooth and fast process
        </div>
        <div style="padding-top: 2em;">
            <ApplicationSelection applicationDataList={applicationDataList}  applicationId={applicationData.applicationId}  on:applicationSelected={applicationSelected} />
            <TopLevelNavigation />
            {#if navState.honestyStatement}
                <HonestyStatement applicationData={applicationData}></HonestyStatement>
            {/if}
        </div>
    </div>

    <div>
        {#if applicationData}
            {#if navState.applicationReview}
                <ApplicationDataContainer on:applicationReviewComplete={applicationReviewComplete} applicationData="{applicationData}" />
            {/if}

            {#if navState.hipaa}
                <HipaaElectronicSignature insured={insured} />
            {/if}

            {#if navState.medicalQuestions}
                <MedicalQuestionsContainer on:medicalInterviewComplete={medicalQuestionsComplete}  />
            {/if}

            {#if navState.identification}
                <IdentificationCard on:identificationImageUploaded={identificationCardComplete}/>
            {/if}

            {#if navState.readyToBeContacted}
                <ReadyToBeContacted />
            {/if}

            {#if navState.phoneInterviewInstructions}
                <PhoneInterviewInstructions />
            {/if}
        {/if}

    </div>


</div>

{#if $IncidentalError}

    <Modal bind:this={errorModal}>
        <h3 style="font-family: Open Sans, sans-serif;">
            <p>We are sorry, an error has occurred.</p>
            <p>Please contact 1-800-366-9378, Option 1 for assistance.</p>
            <p>Our hours of operations are central times 7:30am-6pm Monday thru Thursday, and 7:30am-5pm Friday.</p>

        </h3>

        <div style="padding-top: 2em">
            <button class="pl-cta-primary" on:click={closeModal}>Close</button>

        </div>
    </Modal>
    {/if}
<style lang="scss">
  @use "../../component_scss_library/fonts" as fonts;
  @use "../../component_scss_library/colors" as colors;
  @use "../../component_scss_library/layout" as layout;
  @use "../../component_scss_library/buttons" as buttons;

    .navigation-container {
        @include fonts.primary;

      h1 {
        color: colors.$primary;
        @include fonts.primary-headline;
      }
    }

</style>
